<div
  class="d-flex align-items-center h-100 mr-2 switchButton"
  *ngLet="isOnline && !isUserOptionOffline as isSlideChecked"
>
  <mat-slide-toggle
    data-testId="change-network-status"
    [class]="isSlideChecked ? 'online' : 'offline'"
    [matTooltip]="isSlideChecked ? goOffline : (isOnline && isUserOptionOffline ? offlineWithInternet : offlineWithNoInternet)"
    [checked]="isSlideChecked"
    (change)="onValueChange($event)"
  >
    <ng-container *ngIf="isSlideChecked; else isOfflineTemplate">
      <mat-icon svgIcon="wifi" class="mr-1"></mat-icon>
      <span class="slideToggleLabel mr-2 d-none d-md-block d-xl-none" i18n="@@shared.online.txtOnlineTablet">
        Online
      </span>
      <span class="slideToggleLabel mr-2 d-none d-xl-block" i18n="@@shared.online.txtOnline">You are online</span>
    </ng-container>

    <ng-template #isOfflineTemplate>
      <mat-icon svgIcon="wifi-off" class="mr-1"></mat-icon>
      <span class="slideToggleLabel mr-2 d-none d-md-block d-xl-none" i18n="@@shared.online.txtOfflineTablet">
        Offline
      </span>
      <span class="slideToggleLabel mr-2 d-none d-xl-block" i18n="@@shared.online.txtOffline">You are offline</span>
    </ng-template>
  </mat-slide-toggle>
</div>
